// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"0103d5c3","216":"bae32dd7","453":"8faa970c","800":"d1ccea78"}[chunkId] + ".chunk.js";
};